






















import { Vue, Component } from 'vue-property-decorator';

import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';
import RadioButton from '@/components/Atoms/Input/RadioButton.vue';
import Price from '@/components/Atoms/Text/Price.vue';

@Component({
  components: {
    UnorderedList,
    ListItem,
    RadioButton,
    Price,
  },
})
// 無線LAN機能付きのルータをレンタルしますか。
export default class RentalWifiRouter extends Vue {
  public selectRadioList: { id: string; text: string, price: number }[] = [
    {
      id: 'phone_wireless_router_rental',
      text: '無線LAN機能付きをレンタルする　',
      price: 300
    },
    {
      id: 'phone_not_wireless_router_rental',
      text: '無線LAN機能なしをレンタルする　',
      price: 200
    },
  ];
}
